const list = [
  { name: 'Residencial', id: 1 },
  { name: 'Comercial', id: 2 },
  { name: 'Celular', id: 3 },
  { name: 'Rádio', id: 4 },
];

module.exports = list;
